export const LESSON_TYPE_LECTURE = 1;
export const LESSON_TYPE_PRACTICE = 2;
export const LESSON_TYPE_LAB = 3;
export const FILL_TYPE_UPPER = 1;
export const FILL_TYPE_LOWER = 2;